import { FC } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import { PrismicRichText } from '@prismicio/react';
import {
  BlogPostsSliceColumnsItem,
  BlogPostsSliceColumnsPrimary,
} from '@/types';
import { Icon } from '@/components';
import { BlogFigureImage, BlogPublishDate } from '../Blog.components';

import style from '../blog.module.scss';

const ColumnsVariation: FC<IColumnsProps> = ({ items }) => {
  return (
    <div
      className={classNames(
        style.blogs__articles,
        style.blogs__articles_column_hybrid,
      )}
    >
      {items.map((item, index) => {
        const {
          title,
          description,
          date,
          link,
          user_image,
          full_name,
          position,
        } = item;
        return (
          <article key={`columns-${index}`}>
            <Link
              className={classNames(style.article, style.article_hibryd)}
              href={link || ''}
            >
              <blockquote>
                <PrismicRichText field={title} />
                <PrismicRichText field={description} />
                <div className={style.user}>
                  <p>
                    {full_name}
                    <br />
                    <span>{position}</span>
                  </p>
                  <BlogFigureImage
                    defaultAlt={`Profile picture of ${full_name ?? 'user'}`}
                    image={user_image}
                    noImageContent={<Icon name="perfil-user" />}
                  />
                </div>
              </blockquote>
              <BlogPublishDate publishAt={date} />
            </Link>
          </article>
        );
      })}
    </div>
  );
};

interface IColumnsProps {
  primary: BlogPostsSliceColumnsPrimary;
  items: BlogPostsSliceColumnsItem[];
}

export default ColumnsVariation;
